import { ButtonIconPosition, ButtonSize, ButtonVariant } from "@amzn/stencil-react-components/button";
import IconExternalLink from "@amzn/stencil-react-icons/icons/icon-external-link";
import Button from "@amzn/uxm-stencil-react-components/lib/src/stencil/button";
import React, { FunctionComponent } from "react";

export interface InstallButtonProps {
  url: string;
  label: string;
  testId: string;
  onClick: (url: string) => void;
}

/**
 * Reusable install button component
 */
export const InstallButton: FunctionComponent<InstallButtonProps> = ({ url, label, testId, onClick }) => (
  <Button
    variant={ButtonVariant.Primary}
    size={ButtonSize.Small}
    icon={<IconExternalLink aria-hidden={true} />}
    iconPosition={ButtonIconPosition.Trailing}
    onClick={() => onClick(url)}
    data-testid={testId}
    touchpoint="acme-install-button"
  >
    {label}
  </Button>
);
